import { useMutation } from '@tanstack/react-query';

type BulkTagRequest = {
  ids: number[];
  custom_tag_ids: number[];
};

export default function useBulkAddCompanyTags() {
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement).content;
  return useMutation({
    mutationFn: async (params: BulkTagRequest) => {
      const response = await fetch('/agent/api/companies/bulk_add_tags', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
        body: JSON.stringify(params),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'タグの追加に失敗しました');
      return data;
    },
  });
}
